import directives from '../module';

class EditableCtrl implements ng.IComponentController {
    onChange: Function    = this.onChange || angular.noop;
    private textareaE: HTMLElement;
    private editorEnabled = false;
    private owner: boolean;
    private model: string;
    private prevModel: string;
    private editModel: string;
    private tag: string;
    private defaultMsg: string;

    constructor(private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery,
                private $filter: ng.IFilterService,
                private $timeout: ng.ITimeoutService,
                private $compile: ng.ICompileService) { }

    $postLink() {
        this.textareaE = this.$element[0].querySelector('.textarea');
        const textEl   = this.$element[0].querySelector('#text-el');

        textEl.innerHTML = textEl.innerHTML.replace(/div/, this.tag);
        this.$compile(textEl)(this.$scope);
    }

    private unEdit($event: Event) {
        this.model = this.$filter('stripTags')(angular.copy(this.editModel));
        if (this.model === this.prevModel) return;

        this.prevModel     = this.model;
        this.editorEnabled = false;
        this.$element[0].classList.remove('editing');
        if ($event != null) $event.preventDefault();
        this.onChange({$event: this.model});
        this.textareaE.blur();
    };

    private unEditNoSave($event: Event) {
        this.editorEnabled = false;
        this.$element[0].classList.remove('editing');
        this.editModel = this.model;
        if ($event != null) $event.preventDefault();
    }

    private enableEditor() {
        if (!this.owner) return;
        this.editModel     = angular.copy(this.model);
        this.editorEnabled = true;
        this.$element[0].classList.add('editing');

        this.$timeout(() => this.textareaE.focus());
    }
}

directives.component('editable', {
    bindings: {
        'model': '=model',
        'owner': '=',
        'defaultMsg': '@',
        'tag': '@',
        onChange: '&?'
    },
    controller: EditableCtrl,
    templateUrl: require('project/editable.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/project/editableDirective.ts